import React from "react";
import { useLazyLoad } from "../../helpers/hooks";
const CompApprovedBalls = React.lazy(() => import("./ApprovedBalls"));
const CompClassifiedSurfaces = React.lazy(() => import("./ClassifiedSurfaces"));

export const ApprovedBalls = (props: {
  applyLink: string;
  applyLinkName: string;
}) => useLazyLoad(<CompApprovedBalls {...props} />);

export const ClassifiedSurfaces = (props: {
  applyLink: string;
  applyLinkName: string;
}) => useLazyLoad(<CompClassifiedSurfaces {...props} />);
